import { gql } from '@apollo/client';

import {
  getUnixTime,
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
} from 'date-fns';

import POST_FIELDS from './fragments/post';

const GET_CALENDAR_MONTH_QUERY = gql`
  query GetCalendarMonth(
    $startDate: Int!
    $endDate: Int!
    $seed: Int!
    $channelIds: [ID!]
    $timezone: String!
    $use24HourTime: Boolean!
    $includeDrafts: Boolean
  ) {
    calendar(
      input: {
        startDate: $startDate
        endDate: $endDate
        timezone: $timezone
        use24HourTime: $use24HourTime
        channelIds: $channelIds
        _seed: $seed
        includeDrafts: $includeDrafts
      }
    ) {
      ... on Calendar {
        posts {
          ...PostFields
        }
        days {
          startTimestamp
          dayName
          dayOfMonth
          monthName
          campaigns {
            id
            name
          }
          posts {
            id
          }
        }
      }
    }
  }
  ${POST_FIELDS}
`;

export function mocks(currentDate, channelIds, use24HourTime, seed = 10) {
  const monthStart = startOfMonth(currentDate);
  const monthEnd = endOfMonth(monthStart);
  const startDate = getUnixTime(startOfWeek(monthStart));
  const endDate = getUnixTime(endOfWeek(monthEnd));

  return [
    {
      request: {
        query: GET_CALENDAR_MONTH_QUERY,
        variables: {
          startDate,
          endDate,
          seed,
          channelIds,
          timezone: 'Europe/Madrid',
          use24HourTime,
          includeDrafts: true,
        },
      },
      result: {
        data: {
          calendar: {
            posts: [
              {
                id: '62c8401d43784f68601e0ed2',
                type: 'post',
                text: 'Long bois waggy wags puggorino boof doggo floofs.',
                status: 'pending',
                error: null,
                isReminder: false,
                isCustomScheduled: true,
                isPinned: true,
                formattedTime: '11:29',
                isRetweet: false,
                dueAt: 1678271340,
                title: null,
                createdBy: '62a76434183e2c5e9a63cbf3',
                needsApproval: false,
                sourceUrl: null,
                isBlueprint: null,
                updateType: null,
                threadCount: null,
                channelData: null,
                statistics: null,
                geoLocation: null,
                channel: {
                  id: '62b024d6d477f60c13b4574e',
                  service: 'facebook',
                  avatar:
                    'https://scontent-mad1-1.xx.fbcdn.net/v/t39.30808-1/305487853_599202705235288_3583510889680924600_n.jpg?stp=c0.0.50.50a_cp0_dst-jpg_p50x50&_nc_cat=110&ccb=1-7&_nc_sid=dbb9e7&_nc_ohc=36wDUA1V9M8AX-h8D-S&_nc_ht=scontent-mad1-1.xx&edm=AGaHXAAEAAAA&oh=00_AfC2XLn_bhSeBfW5WbDB1NwuHS7t9wBsAMu12Km9wYgO6g&oe=63A07B32',
                  username: 'Global Pet Page',
                  serverUrl: null,
                  locationData: null,
                },
                subprofile: null,
                attachments: null,
                media: [
                  {
                    thumbnail:
                      'https://buffer-media-uploads-dev.s3.amazonaws.com/62a76434183e2c5e9a63cbf3/62c83ff7c629d413bd106863/585761ebffcbfd2a33c5b5f3fb314b1c.original.jpeg',
                    type: 'image',
                  },
                ],
                campaign: {
                  name: 'Campaign test',
                  color: {
                    value: '#FADE2A',
                  },
                },
              },
            ],
            days: [
              {
                startTimestamp: 1677366000,
                dayName: 'Sunday',
                dayOfMonth: 26,
                monthName: 'February',
                campaigns: null,
                posts: [],
              },
              {
                startTimestamp: 1677452400,
                dayName: 'Monday',
                dayOfMonth: 27,
                monthName: 'February',
                campaigns: null,
                posts: [],
              },
              {
                startTimestamp: 1677538800,
                dayName: 'Tuesday',
                dayOfMonth: 28,
                monthName: 'February',
                campaigns: null,
                posts: [],
              },
              {
                startTimestamp: 1677625200,
                dayName: 'Wednesday',
                dayOfMonth: 1,
                monthName: 'March',
                campaigns: null,
                posts: [],
              },
              {
                startTimestamp: 1677711600,
                dayName: 'Thursday',
                dayOfMonth: 2,
                monthName: 'March',
                campaigns: null,
                posts: [],
              },
              {
                startTimestamp: 1677798000,
                dayName: 'Friday',
                dayOfMonth: 3,
                monthName: 'March',
                campaigns: null,
                posts: [],
              },
              {
                startTimestamp: 1677884400,
                dayName: 'Saturday',
                dayOfMonth: 4,
                monthName: 'March',
                campaigns: null,
                posts: [],
              },
              {
                startTimestamp: 1677970800,
                dayName: 'Sunday',
                dayOfMonth: 5,
                monthName: 'March',
                campaigns: null,
                posts: [],
              },
              {
                startTimestamp: 1678057200,
                dayName: 'Monday',
                dayOfMonth: 6,
                monthName: 'March',
                campaigns: null,
                posts: [],
              },
              {
                startTimestamp: 1678143600,
                dayName: 'Tuesday',
                dayOfMonth: 7,
                monthName: 'March',
                campaigns: null,
                posts: [],
              },
              {
                startTimestamp: 1678230000,
                dayName: 'Wednesday',
                dayOfMonth: 8,
                monthName: 'March',
                campaigns: null,
                posts: [
                  {
                    id: '62c8401d43784f68601e0ed2',
                  },
                ],
              },
              {
                startTimestamp: 1678316400,
                dayName: 'Thursday',
                dayOfMonth: 9,
                monthName: 'March',
                campaigns: null,
                posts: [],
              },
              {
                startTimestamp: 1678402800,
                dayName: 'Friday',
                dayOfMonth: 10,
                monthName: 'March',
                campaigns: null,
                posts: [],
              },
              {
                startTimestamp: 1678489200,
                dayName: 'Saturday',
                dayOfMonth: 11,
                monthName: 'March',
                campaigns: null,
                posts: [],
              },
              {
                startTimestamp: 1678575600,
                dayName: 'Sunday',
                dayOfMonth: 12,
                monthName: 'March',
                campaigns: null,
                posts: [],
              },
              {
                startTimestamp: 1678662000,
                dayName: 'Monday',
                dayOfMonth: 13,
                monthName: 'March',
                campaigns: null,
                posts: [],
              },
              {
                startTimestamp: 1678748400,
                dayName: 'Tuesday',
                dayOfMonth: 14,
                monthName: 'March',
                campaigns: null,
                posts: [],
              },
              {
                startTimestamp: 1678834800,
                dayName: 'Wednesday',
                dayOfMonth: 15,
                monthName: 'March',
                campaigns: null,
                posts: [],
              },
              {
                startTimestamp: 1678921200,
                dayName: 'Thursday',
                dayOfMonth: 16,
                monthName: 'March',
                campaigns: null,
                posts: [],
              },
              {
                startTimestamp: 1679007600,
                dayName: 'Friday',
                dayOfMonth: 17,
                monthName: 'March',
                campaigns: null,
                posts: [],
              },
              {
                startTimestamp: 1679094000,
                dayName: 'Saturday',
                dayOfMonth: 18,
                monthName: 'March',
                campaigns: null,
                posts: [],
              },
              {
                startTimestamp: 1679180400,
                dayName: 'Sunday',
                dayOfMonth: 19,
                monthName: 'March',
                campaigns: null,
                posts: [],
              },
              {
                startTimestamp: 1679266800,
                dayName: 'Monday',
                dayOfMonth: 20,
                monthName: 'March',
                campaigns: null,
                posts: [],
              },
              {
                startTimestamp: 1679353200,
                dayName: 'Tuesday',
                dayOfMonth: 21,
                monthName: 'March',
                campaigns: null,
                posts: [],
              },
              {
                startTimestamp: 1679439600,
                dayName: 'Wednesday',
                dayOfMonth: 22,
                monthName: 'March',
                campaigns: null,
                posts: [],
              },
              {
                startTimestamp: 1679526000,
                dayName: 'Thursday',
                dayOfMonth: 23,
                monthName: 'March',
                campaigns: null,
                posts: [],
              },
              {
                startTimestamp: 1679612400,
                dayName: 'Friday',
                dayOfMonth: 24,
                monthName: 'March',
                campaigns: null,
                posts: [],
              },
              {
                startTimestamp: 1679698800,
                dayName: 'Saturday',
                dayOfMonth: 25,
                monthName: 'March',
                campaigns: null,
                posts: [],
              },
              {
                startTimestamp: 1679785200,
                dayName: 'Sunday',
                dayOfMonth: 26,
                monthName: 'March',
                campaigns: null,
                posts: [],
              },
              {
                startTimestamp: 1679868000,
                dayName: 'Monday',
                dayOfMonth: 27,
                monthName: 'March',
                campaigns: null,
                posts: [],
              },
              {
                startTimestamp: 1679954400,
                dayName: 'Tuesday',
                dayOfMonth: 28,
                monthName: 'March',
                campaigns: null,
                posts: [],
              },
              {
                startTimestamp: 1680040800,
                dayName: 'Wednesday',
                dayOfMonth: 29,
                monthName: 'March',
                campaigns: null,
                posts: [],
              },
              {
                startTimestamp: 1680127200,
                dayName: 'Thursday',
                dayOfMonth: 30,
                monthName: 'March',
                campaigns: null,
                posts: [],
              },
              {
                startTimestamp: 1680213600,
                dayName: 'Friday',
                dayOfMonth: 31,
                monthName: 'March',
                campaigns: null,
                posts: [],
              },
              {
                startTimestamp: 1680300000,
                dayName: 'Saturday',
                dayOfMonth: 1,
                monthName: 'April',
                campaigns: null,
                posts: [],
              },
            ],
          },
        },
      },
    },
  ];
}

export default GET_CALENDAR_MONTH_QUERY;
